/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  AuthCallbackAuthSsoCallbackGetParams,
  ErrorResponse,
  HTTPValidationError,
  RefreshRequest,
  TokenPair,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Redirects a tenant admin to Microsoft to grant consent for the tenant's Entra application.
 * @summary Initiate Microsoft admin consent
 */
export const initiateConsentAuthSsoConsentGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<unknown>(
    { url: `/auth/sso/consent`, method: "GET", signal },
    options
  );
};

export const getInitiateConsentAuthSsoConsentGetQueryKey = () => {
  return [`/auth/sso/consent`] as const;
};

export const getInitiateConsentAuthSsoConsentGetQueryOptions = <
  TData = Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getInitiateConsentAuthSsoConsentGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>
  > = ({ signal }) => initiateConsentAuthSsoConsentGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type InitiateConsentAuthSsoConsentGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>
>;
export type InitiateConsentAuthSsoConsentGetQueryError = ErrorType<unknown>;

export function useInitiateConsentAuthSsoConsentGet<
  TData = Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
          TError,
          Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useInitiateConsentAuthSsoConsentGet<
  TData = Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
          TError,
          Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useInitiateConsentAuthSsoConsentGet<
  TData = Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Initiate Microsoft admin consent
 */

export function useInitiateConsentAuthSsoConsentGet<
  TData = Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof initiateConsentAuthSsoConsentGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getInitiateConsentAuthSsoConsentGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Redirects the user to Microsoft to authenticate via SSO.
 * @summary Initiate Microsoft SSO login
 */
export const ssoLoginAuthSsoLoginGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<unknown>(
    { url: `/auth/sso/login`, method: "GET", signal },
    options
  );
};

export const getSsoLoginAuthSsoLoginGetQueryKey = () => {
  return [`/auth/sso/login`] as const;
};

export const getSsoLoginAuthSsoLoginGetQueryOptions = <
  TData = Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSsoLoginAuthSsoLoginGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>
  > = ({ signal }) => ssoLoginAuthSsoLoginGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SsoLoginAuthSsoLoginGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>
>;
export type SsoLoginAuthSsoLoginGetQueryError = ErrorType<unknown>;

export function useSsoLoginAuthSsoLoginGet<
  TData = Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
          TError,
          Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSsoLoginAuthSsoLoginGet<
  TData = Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
          TError,
          Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSsoLoginAuthSsoLoginGet<
  TData = Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Initiate Microsoft SSO login
 */

export function useSsoLoginAuthSsoLoginGet<
  TData = Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ssoLoginAuthSsoLoginGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSsoLoginAuthSsoLoginGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Shared callback for both admin consent and SSO login. Consent callbacks include `admin_consent=True`; login callbacks include `code`.
 * @summary Microsoft OAuth callback
 */
export const authCallbackAuthSsoCallbackGet = (
  params?: AuthCallbackAuthSsoCallbackGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<unknown>(
    { url: `/auth/sso/callback`, method: "GET", params, signal },
    options
  );
};

export const getAuthCallbackAuthSsoCallbackGetQueryKey = (
  params?: AuthCallbackAuthSsoCallbackGetParams
) => {
  return [`/auth/sso/callback`, ...(params ? [params] : [])] as const;
};

export const getAuthCallbackAuthSsoCallbackGetQueryOptions = <
  TData = Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: AuthCallbackAuthSsoCallbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAuthCallbackAuthSsoCallbackGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>
  > = ({ signal }) =>
    authCallbackAuthSsoCallbackGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthCallbackAuthSsoCallbackGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>
>;
export type AuthCallbackAuthSsoCallbackGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useAuthCallbackAuthSsoCallbackGet<
  TData = Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: undefined | AuthCallbackAuthSsoCallbackGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
          TError,
          Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthCallbackAuthSsoCallbackGet<
  TData = Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: AuthCallbackAuthSsoCallbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
          TError,
          Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthCallbackAuthSsoCallbackGet<
  TData = Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: AuthCallbackAuthSsoCallbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Microsoft OAuth callback
 */

export function useAuthCallbackAuthSsoCallbackGet<
  TData = Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: AuthCallbackAuthSsoCallbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authCallbackAuthSsoCallbackGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAuthCallbackAuthSsoCallbackGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Refresh Tokens
 */
export const refreshTokensAuthRefreshPost = (
  refreshRequest: BodyType<RefreshRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<TokenPair>(
    {
      url: `/auth/refresh`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: refreshRequest,
      signal,
    },
    options
  );
};

export const getRefreshTokensAuthRefreshPostMutationKey = () =>
  ["refreshTokensAuthRefreshPost"] as const;

export const getRefreshTokensAuthRefreshPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshTokensAuthRefreshPost>>,
    TError,
    RefreshTokensAuthRefreshPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshTokensAuthRefreshPost>>,
  TError,
  RefreshTokensAuthRefreshPostMutationVariables,
  TContext
> => {
  const mutationKey = getRefreshTokensAuthRefreshPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshTokensAuthRefreshPost>>,
    RefreshTokensAuthRefreshPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return refreshTokensAuthRefreshPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshTokensAuthRefreshPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshTokensAuthRefreshPost>>
>;
export type RefreshTokensAuthRefreshPostMutationBody = BodyType<RefreshRequest>;
export type RefreshTokensAuthRefreshPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface RefreshTokensAuthRefreshPostMutationVariables {
  data: BodyType<RefreshRequest>;
}

/**
 * @summary Refresh Tokens
 */
export const useRefreshTokensAuthRefreshPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshTokensAuthRefreshPost>>,
      TError,
      RefreshTokensAuthRefreshPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof refreshTokensAuthRefreshPost>>,
  TError,
  RefreshTokensAuthRefreshPostMutationVariables,
  TContext
> => {
  return useMutation(
    getRefreshTokensAuthRefreshPostMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Logout
 */
export const logoutAuthLogoutPost = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<void>(
    { url: `/auth/logout`, method: "POST", signal },
    options
  );
};

export const getLogoutAuthLogoutPostMutationKey = () =>
  ["logoutAuthLogoutPost"] as const;

export const getLogoutAuthLogoutPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutAuthLogoutPost>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logoutAuthLogoutPost>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getLogoutAuthLogoutPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logoutAuthLogoutPost>>,
    void
  > = () => {
    return logoutAuthLogoutPost(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutAuthLogoutPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof logoutAuthLogoutPost>>
>;

export type LogoutAuthLogoutPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Logout
 */
export const useLogoutAuthLogoutPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof logoutAuthLogoutPost>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof logoutAuthLogoutPost>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getLogoutAuthLogoutPostMutationOptions(options),
    queryClient
  );
};
